import { Tag } from "@tine/designsystem-ui-react";

import { formatPrice } from "../common/utils";

type DisplayPriceProps = {
   price: number;
   newPrice: number;
   className?: string;
   postPriceDetail?: string;
};

const DisplayPrice = ({ price, newPrice, className, postPriceDetail }: DisplayPriceProps) => {
   // Sometimes the discounted price decimals have different rounding than the full price, so we check if the difference is small
   const isDiscounted = price - newPrice >= 1;

   return (
      <div className={className}>
         {isDiscounted && (
            <div className="text-sm text-muted line-through">
               <strong>{formatPrice(price)}</strong>
            </div>
         )}
         <div className={`font-bold leading-4 ${isDiscounted ? "text-promotion" : ""}`}>
            {formatPrice(newPrice)}
            {postPriceDetail && (
               <Tag
                  bgColor="#fafafa"
                  className="text-ink-brand-default relative top-[-2px] ml-2 inline-block text-xs font-normal"
               >
                  {postPriceDetail}
               </Tag>
            )}
         </div>
      </div>
   );
};

export default DisplayPrice;
